import { render, staticRenderFns } from "./AdminLogTable.vue?vue&type=template&id=6874b024&"
import script from "./AdminLogTable.vue?vue&type=script&lang=js&"
export * from "./AdminLogTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogTable.vue?vue&type=style&index=0&id=6874b024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports